// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--r9kKa";
export var lightFooter = "Footer-module--lightFooter--L6+rf";
export var link = "Footer-module--link--ixJIY";
export var links = "Footer-module--links--NGNqE";